import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ComputerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ComputerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.3415 6.65881H3.23871C2.76855 6.65881 2.38574 7.04133 2.38574 7.51149V15.0457C2.38574 15.5159 2.76855 15.8984 3.23871 15.8984H6.89757L6.59196 16.9693H6.41086C6.15924 16.9693 5.95463 17.1736 5.95463 17.425C5.95463 17.6769 6.15924 17.8812 6.41086 17.8812H11.1694C11.421 17.8812 11.6256 17.6769 11.6256 17.425C11.6256 17.1736 11.421 16.9693 11.1694 16.9693H10.9877L10.6821 15.8984H14.3415C14.8117 15.8984 15.1945 15.5159 15.1945 15.0457V7.51149C15.1945 7.04133 14.8117 6.65881 14.3415 6.65881ZM7.54041 16.9693L7.84515 15.9013L9.73422 15.9007L10.0393 16.9693L7.54041 16.9693ZM14.282 14.9865H3.2982V14.3126H14.282L14.282 14.9865ZM14.282 13.4007H3.2982V7.5707H14.282L14.282 13.4007Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.6986 6.65881H16.9401C16.6885 6.65881 16.4839 6.86313 16.4839 7.11504V17.425C16.4839 17.6769 16.6885 17.8812 16.9401 17.8812H21.6986C21.95 17.8812 22.1543 17.6769 22.1543 17.425V7.11504C22.1543 6.86313 21.95 6.65881 21.6986 6.65881ZM21.2424 16.9693H17.3958V7.57069H21.2424V16.9693Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4977 9.15703H20.2826C20.5339 9.15703 20.7383 8.95271 20.7383 8.70138C20.7383 8.45005 20.5339 8.24573 20.2826 8.24573H18.4977C18.2461 8.24573 18.0415 8.45005 18.0415 8.70138C18.0415 8.95271 18.2461 9.15703 18.4977 9.15703Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4977 10.743H20.2826C20.5339 10.743 20.7383 10.5386 20.7383 10.2873C20.7383 10.036 20.5339 9.83167 20.2826 9.83167H18.4977C18.2461 9.83167 18.0415 10.036 18.0415 10.2873C18.0415 10.5386 18.2461 10.743 18.4977 10.743Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4977 12.3289H20.2826C20.5339 12.3289 20.7383 12.1246 20.7383 11.8733C20.7383 11.6219 20.5339 11.4176 20.2826 11.4176H18.4977C18.2461 11.4176 18.0415 11.6219 18.0415 11.8733C18.0415 12.1246 18.2461 12.3289 18.4977 12.3289Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3195 14.194C19.0679 14.194 18.8633 14.3977 18.8633 14.649C18.8633 14.9004 19.0679 15.1047 19.3195 15.1047C19.5708 15.1047 19.7752 14.9004 19.7752 14.649C19.7752 14.3977 19.5708 14.194 19.3195 14.194Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ComputerIcon;
